import {
    AuditedActions,
    auditLogApi,
    AuditLogSearchRequest,
    AuditLogsSearchResult,
} from "@/api/auditLogs";
import { defineStore } from "pinia";
import { useQueryCache } from "@pinia/colada";
import { ensureQueryData } from "@/queries/utils";

export const AUDIT_LOG_KEYS = {
    root: ["auditLogs"] as const,
    tables: () => [...AUDIT_LOG_KEYS.root, "tables"] as const,
};

const tableNamesQueryOptions = {
    key: AUDIT_LOG_KEYS.tables(),
    query: () => auditLogApi.getTablesNames(),
    staleTime: 5 * 60_000,
};

export type AuditLogsState = {
    search: {
        searched: boolean;
        request: AuditLogSearchRequest;
        options: {
            page: number;
            perPage: number;
        };
    };
    results: AuditLogsSearchResult;
};

export const useAuditLogsStore = defineStore("auditLogs", {
    state: (): AuditLogsState => ({
        search: {
            searched: false,
            request: {
                action: AuditedActions.All,
                sortBy: null,
                direction: null,
                tables: null,
                timeRangeStart: null,
                timeRangeEnd: null,
                users: null,
            },
            options: {
                page: 0,
                perPage: 50,
            },
        },
        results: {
            logs: [],
            total: 0,
        },
    }),
    getters: {
        tables(): string[] {
            return useQueryCache().getQueryData<string[]>(AUDIT_LOG_KEYS.tables()) ?? [];
        },
    },
    actions: {
        async searchLogs() {
            const search = this.$state.search;
            const result = await auditLogApi.search(
                search.request,
                search.options.page,
                search.options.perPage
            );

            this.$state.search.searched = true;

            this.$state.results.logs = result.logs;
            this.$state.results.total = result.total;
        },
        async loadTableNames(force = false) {
            await ensureQueryData(tableNamesQueryOptions, force);
        },
    },
});
